'use strict';

const { initializeSliders } = require('./sliders');

$(() => {
    /**
     * Patch WCAG 2.2 AA for Bootstrap 4.6 modals
     * - Saves and restores last focused element
     * - Ensures focus trap inside modal
     */
    function patchModalAccessibility() {
        let lastFocusedBeforeModal = null;

        // Move focus out of modal before Bootstrap sets aria-hidden on close
        $(document).on('hide.bs.modal', '.modal', function () {
            if (this.contains(document.activeElement)) {
                document.activeElement.blur();
            }
        });

        // Save focus BEFORE Bootstrap moves it
        $(document).on('show.bs.modal', '.modal', function () {
            if (
                !$('body').hasClass('using-mouse') &&
                !$(document.activeElement).closest('.modal, .cc-overlay, .js-overlay').length
            ) {
                lastFocusedBeforeModal = document.activeElement;
            }
        });

        // Hide main content and focus modal
        $(document).on('shown.bs.modal', '.modal', function () {
            const $modal = $(this);
            const $header = $('.cc-header');
            const isInsideHeader = $modal.closest($header).length > 0;
            if (isInsideHeader) {
                $modal.siblings().attr('aria-hidden', 'true').attr('data-modal-hidden', 'true');
            } else {
                $header.attr('aria-hidden', 'true').attr('data-modal-hidden', 'true');
            }
            $('#maincontent, .cc-footer').attr('aria-hidden', 'true').attr('data-modal-hidden', 'true');

            const $sliders = $(this).find('.js-slider:not(.slick-initialized)');
            if ($sliders.length > 0) {
                initializeSliders($sliders);
            }

            if (!$('body').hasClass('using-mouse')) {
                $modal.attr('tabindex', '-1').focus();
            }
        });

        // Restore focus and clean aria-hidden
        $(document).on('hidden.bs.modal', '.modal', function () {
            if (
                lastFocusedBeforeModal &&
                typeof lastFocusedBeforeModal.focus === 'function' &&
                document.body.contains(lastFocusedBeforeModal)
            ) {
                lastFocusedBeforeModal.focus();
            }
            lastFocusedBeforeModal = null;

            if ($('.modal.show').length === 0) {
                $('[data-modal-hidden]').removeAttr('aria-hidden').removeAttr('data-modal-hidden');
            }
        });

        // Trap focus inside modal
        $(document).on('keydown', '.modal', function (e) {
            if (e.key !== 'Tab') return;

            const $modal = $(this);
            const $focusable = $modal.find(
                'a[href], area[href], input:not([disabled]):not([type=hidden]), ' +
                'select:not([disabled]), textarea:not([disabled]), ' +
                'button:not([disabled]), iframe, object, embed, ' +
                '[tabindex]:not([tabindex="-1"]):not(.modal), [contenteditable=true]'
            ).filter(':visible');

            if ($focusable.length === 0) return;

            const first = $focusable[0];
            const last = $focusable[$focusable.length - 1];

            if (e.shiftKey && document.activeElement === first) {
                e.preventDefault();
                last.focus();
            } else if (!e.shiftKey && document.activeElement === last) {
                e.preventDefault();
                first.focus();
            }

            const $iframe = $modal.find('iframe').filter(':visible');
            if ($iframe.length > 0) {
                $iframe.each(function () {
                    try {
                        const iframeDoc = this.contentDocument || this.contentWindow.document;
                        $(iframeDoc).off('keydown.trapfocus').on('keydown.trapfocus', function (event) {
                            if (event.key === 'Tab') {
                                event.preventDefault();
                                if (e.shiftKey) {
                                    last.focus();
                                } else {
                                    first.focus();
                                }
                            }
                        });
                    } catch (err) {
                        console.warn('Cannot trap focus in cross-domain iframe');
                    }
                });
            }
        });

        // Fallback: clean aria-hidden if modal is removed directly (non-standard)
        const modalObserver = new MutationObserver(() => {
            if ($('.modal.show').length === 0) {
                $('[data-modal-hidden]').removeAttr('aria-hidden').removeAttr('data-modal-hidden');
            }
        });

        modalObserver.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    function patchIframeFocusTrap() {
        $(document).on('focusin', '.js-trap-iframe-out', function () {
            const $modal = $('.modal.show');

            if ($modal.length > 0) {
                const $focusable = $modal.find(
                    'a[href], area[href], input:not([disabled]):not([type=hidden]), ' +
                    'select:not([disabled]), textarea:not([disabled]), ' +
                    'button:not([disabled]), iframe, object, embed, ' +
                    '[tabindex]:not([tabindex="-1"]):not(.modal), [contenteditable=true]'
                ).filter(':visible');

                if ($focusable.length > 0) {
                    $focusable.first().focus();
                }
            }
        });
    }

    patchModalAccessibility();
    patchIframeFocusTrap();
});
